"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.driverRatingDeserialize = void 0;
const deserializeNumber_1 = require("./deserializeNumber");
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
const FirestoreTimestamp_1 = require("./firebase/FirestoreTimestamp");
function driverRatingDeserialize(value, id) {
    const object = (0, deserializeObject_1.default)(value);
    const stars = (0, deserializeNumber_1.deserializeNumber)(object.stars);
    if (![1, 2, 3, 4, 5].includes(stars)) {
        throw new Error('Invalid stars count');
    }
    return {
        id: (0, deserializeString_1.deserializeString)(id),
        driverId: (0, deserializeString_1.deserializeString)(object.driverId),
        stars: stars,
        timestamp: (0, FirestoreTimestamp_1.firestoreTimestampDeserialize)(object.timestamp),
    };
}
exports.driverRatingDeserialize = driverRatingDeserialize;
